import { HttpClient } from "@angular/common/http";
import { Inject, Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import { ProcedureDto } from "@shared/models/http/procedures/procedure-dto";
import { OdataResult } from "@shared/models/http/odata-result";
import { IEnvironmentConfig } from "@webpack/extra-webpack-types";
import { TreatmentDto } from "@shared/models/http/practice-fees/treatment-dto";
import { TreatmentOptionDto } from "@shared/models/http/practice-fees/treatment-option-dto";
import { AdditionalCostDto } from "@shared/models/http/practice-fees/additional-cost-dto";
import { MiscChargeDto } from "@shared/models/http/practice-fees/misc-charge-dto";

@Injectable({
  providedIn: "root",
})
export class ProcedureService {
  constructor(
    @Inject("ENV") private _env: IEnvironmentConfig,
    private _http: HttpClient
  ) {}

  public getAll(): Observable<ProcedureDto[]> {
    return this._http
      .get<OdataResult<ProcedureDto[]>>(
        `${this._env.apiGatewayUrl}/odata/procedure`,
        {
          withCredentials: true,
        }
      )
      .pipe(map((data) => data.value));
  }

  public getProcedureName(
    data: AdditionalCostDto | MiscChargeDto | TreatmentDto | TreatmentOptionDto
  ): string {
    if (!data.procedure) {
      return "";
    }
    if (typeof data.procedure === "string") {
      return data.procedure;
    } else {
      return data.procedure.category
        ? `${data.procedure.code} - ${data.procedure.category}`
        : data.procedure.code;
    }
  }
}
